<script setup lang="ts">
/**
 * Mascotte Donoor qui lance des petits cœurs, sur une pastille étoilée noire
 * (Karim 2026-10-13). UN SEUL composant pour le « Coup de cœur Donoor » et le
 * toast « en direct » (quelqu'un vient de donner) : les changer ici les
 * change partout.
 *
 * Dessinée à 64 px puis mise à l'échelle (`taille`) : mêmes proportions et
 * même envol des cœurs, quelle que soit la taille.
 */
import DonoorMascotte from "~/components/shared/DonoorMascotte.vue";

const props = withDefaults(defineProps<{ taille?: number }>(), { taille: 64 });

/** Cœurs : position de départ, taille, décalage, dérive. */
const COEURS = [
  { x: "38%", taille: 11, delai: "0s", derive: "-10px" },
  { x: "52%", taille: 9, delai: "0.9s", derive: "9px" },
  { x: "44%", taille: 12, delai: "1.8s", derive: "-4px" },
];
</script>

<template>
  <div class="relative shrink-0" :style="{ width: `${props.taille}px`, height: `${props.taille}px` }" aria-hidden="true">
    <div
      class="absolute left-0 top-0 h-16 w-16 origin-top-left"
      :style="{ transform: `scale(${props.taille / 64})` }"
    >
      <div class="relative h-full w-full rotate-12">
          <svg viewBox="0 0 64 64" class="absolute inset-0 w-full h-full text-(--color-ink)">
            <path
              fill="currentColor"
              d="M32 2l5.6 6.4 8.3-2.1 2.4 8.2 8.2 2.4-2.1 8.3L61 32l-6.4 5.6 2.1 8.3-8.2 2.4-2.4 8.2-8.3-2.1L32 61l-5.6-6.4-8.3 2.1-2.4-8.2-8.2-2.4 2.1-8.3L3 32l6.4-5.6-2.1-8.3 8.2-2.4 2.4-8.2 8.3 2.1z"
            />
          </svg>
          <!-- La mascotte du chat Donoor, version blanche (yeux noirs) -->
          <DonoorMascotte class="absolute inset-0 m-auto !w-7 !h-7 -rotate-12" />
          <!-- Petits cœurs qui s'envolent de la mascotte, en boucle et décalés -->
          <svg
            v-for="(c, i) in COEURS"
            :key="i"
            viewBox="0 0 24 24"
            class="coeur absolute"
            :style="{ left: c.x, width: `${c.taille}px`, height: `${c.taille}px`, animationDelay: c.delai, '--derive': c.derive }"
          >
            <path
              fill="#ff4d6d"
              d="M12 21s-7.5-4.6-9.6-9.2C.9 8.4 3 5 6.4 5c2 0 3.6 1.1 4.6 2.6h2C14 6.1 15.6 5 17.6 5 21 5 23.1 8.4 21.6 11.8 19.5 16.4 12 21 12 21z"
            />
          </svg>
      </div>
    </div>
  </div>
</template>

<style scoped>
/* Les cœurs montent depuis la mascotte en grossissant, dérivent un peu puis
   s'effacent — 2,7 s par cœur, trois cœurs décalés : il y en a toujours un. */
.coeur {
  top: 30%;
  opacity: 0;
  animation: coeur-envol 2.7s ease-out infinite;
  will-change: transform, opacity;
}
@keyframes coeur-envol {
  0% {
    opacity: 0;
    transform: translate(0, 0) scale(0.4) rotate(-12deg);
  }
  15% {
    opacity: 1;
  }
  100% {
    opacity: 0;
    transform: translate(var(--derive), -38px) scale(1) rotate(-12deg);
  }
}
@media (prefers-reduced-motion: reduce) {
  .coeur {
    display: none;
  }
}
</style>
